import { getModifiers } from '@helpers/functions';
import { IconModel } from '@_types/types';

interface Props extends IconModel {
  onClick?: () => any;
  className?: string;
  id?: string;
}

const Icon = (model: Props) => {
  const { title, height, iconPath, viewBoxHeight, viewBoxWidth, width, onClick, ariaHidden, ariaLabelledby, id, className } = model;
  const styleModifiers = getModifiers(model, 'saig-a-icon');
  const href = iconPath.startsWith('#') ? '/assets/images/icons.svg' + iconPath : iconPath;

  let viewBox;

  if (viewBoxWidth && viewBoxHeight) {
    viewBox = `0 0 ${viewBoxWidth} ${viewBoxHeight}`;
  }

  return (
    <svg
      id={id}
      aria-labelledby={ariaLabelledby}
      onClick={onClick}
      className={`${className ?? ''} ${styleModifiers}`}
      aria-hidden={ariaHidden ?? 'true'}
      viewBox={viewBox}
      width={width || viewBoxWidth}
      height={height || viewBoxHeight}
    >
      {title && ariaLabelledby && <title id={ariaLabelledby}>{title}</title>}
      <use xlinkHref={href}></use>
    </svg>
  );
};

export { Icon };
export default Icon;
